<template>
    <base-dialog :loading="loading" :value="dialog" :width="480" :fullscreen="isMobile" :title="$t('entrance.basic_info')"
        @input="val => { if (!val) hide() }" @close="hide">
        <basic-info v-if="dialog" no-title @change="onChange" ref="basicInfo" />

        <template v-slot:footer>
            <dialog-actions :confirm-label="$t('common.save')" :loading="loading" :disabled="disabled" @cancel="hide"
                @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>
import { mapActions } from "vuex";
import firebase, { db } from "@/utils/Firebase";
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";
import BasicInfo from "@/components/company/BasicInfo";

export default {
    name: "EditCompanyInfoDialog",
    components: { BaseDialog, DialogActions, BasicInfo },
    data() {
        return {
            dialog: false,
            loading: false,
            form: null,
        }
    },
    computed: {
        disabled(vm = this) {
            return vm.form ? !vm.form.name : !vm.account?.name
        },
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        updatePhoneStripe: firebase.functions().httpsCallable('httpPayments-updatePhoneStripe'),
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.form = null
        },
        onChange(form) {
            this.form = form
        },
        async save() {
            const vm = this
            if (vm.$refs.basicInfo) vm.$refs.basicInfo.emitNow()
            await vm.$nextTick()
            if (!vm.form?.name) return

            await vm.withLoading(async () => {
                const phoneChanged = vm.form.phone && vm.form.phone !== vm.account?.phone

                await db.collection('users').doc(vm.currentUser.uid).update({
                    name: vm.form.name,
                    phone: vm.form.phone || '',
                    phoneCode: vm.form.phoneCode || '',
                    country: vm.form.country || '',
                    address: vm.form.address || '',
                    type: vm.form.type || '',
                })

                if (phoneChanged) await vm.updatePhoneStripe()

                await vm.bindUserAccount(vm.currentUser)

                vm.hide()
                vm.toast(vm.$t('common.changes_saved'))
            })
        },
    },
}
</script>
